@if (hasContent) {
  <div class="status-center" role="region" aria-label="Chat status">
    @if (hasRefProgress) {
      <app-ref-progress [progress]="referenceProgress"></app-ref-progress>
    } @else if (dynamicStatus) {
      <div class="status-center__line" role="status">{{ dynamicStatus }}</div>
    } @else if (isWriting) {
      <div class="status-center__line" role="status">Generating response...</div>
    }
  </div>
}
